import { BreadcrumbsService, Breadcrumb } from '@exalif/ngx-breadcrumbs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
  providers: [BreadcrumbsService]
})
export class BreadcrumbComponent implements OnInit {

  breadCrumbList: Breadcrumb[];

  constructor(
    private _breadCrumbsService: BreadcrumbsService,
    private _route: Router) {
    this._breadCrumbsService.crumbs$.subscribe(res => {
      this.breadCrumbList = res;
    });
   }

  ngOnInit() {
  }


  breadCrumbOnClick(path) {

    if (this._route.url === path) {
      return;
    }
    this._route.navigate([path]);

  }


}
